import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trash",
  "use": "icon-trash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-trash\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M15,7h2V9H16v8a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V9H6V7H8V6h7Zm-5,3v5h1V10Zm2,0v5h1V10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol